
const initialState = {
  data: [],
  loading: false,
  success: false,
  error: false,
  filterValues: undefined,
};

export const reportActivityList = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `REPORT_ACTIVITY_LIST_REQUEST_REQUEST`: {
      return { ...initialState, data: state.data || [], loading: true };
    }
    case `REPORT_ACTIVITY_LIST_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: false, loading: false };
    }
    case `REPORT_ACTIVITY_LIST_REQUEST_FAILURE`: {
      return { ...state, data: [], success: false, error: action.error, loading: false };
    }
    case `REPORT_ACTIVITY_LIST_REQUEST_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
